import styled from 'styled-components';

import {
  device
} from '../../utils';

export const Wrapper = styled.div `
  margin: 75px 0 0 0;
  background: #000;
  color: #fff;

  .bigtitle {
    font-size: 20px;
    line-height: 1em;
    margin-top: 0;
  }

  .container {
    padding-top: 55px;
    padding-bottom: 55px;
    text-align: center;

    ul {
      display: grid;
      grid-template-columns: 1fr 1fr;
      list-style: none;
      margin-left: 0;
      padding-left: 0;
      align-items: flex-end;
      margin: 50px 15px 0 15px;

      li {
        padding: 30px;
        line-height: 1.3em;
        font-size: 14px;

        &:nth-child(odd) {
          border-right: 1px solid #fff;
          padding-left: 0px;
        }
        &:nth-child(even) {
          padding-right: 10px;
        }

        &:nth-child(-n + 2) {
          padding-top: 0;
          border-bottom: 1px solid #fff;
        }

        &:nth-child(n + 3) {
          padding-bottom: 0;
        }

        strong {
          display: block;
          font-weight: bold;
        }

        .icon {
          height: 40px;
          margin-bottom: 10px;
        }
      }
    }
  }

  svg {
    *,
    g {
      fill: #c80f05 !important;
    }
  }

  @media ${device.tablet} {
    .bigtitle {
      margin-bottom: 35px;
    }

    .container {
      padding-top: 55px;
      padding-bottom: 55px;

      ul {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        grid-template-columns: none;
        grid-gap: 0;
        margin-top: 30px;

        li {
          flex: 1;
          &:nth-child(n) {
            padding: 0 30px;
            border: none;
            border-right: 1px solid #fff;
          }
          .icon {
            height: 50px;
          }

          &:last-child {
            border-right: none;
          }
        }
      }
    }
  }
`;